import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Error from '../views/404.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        hasProps: true,
        props: {
            title: 'Assurity'
        }
    },
    {
        path: '/404',
        name: '404',
        component: Error
    },
    {
        path: '/:id',
        name: 'Overview',
        component: () => import('../views/Overview.vue')
    },
    {
        path: '/:id/accident-expense/',
        name: 'AccidentExpense',
        component: () => import('../views/AccidentExpense.vue'),
        hasProps: true,
        props: {
            productName: 'Group Accident Expense Insurance',
            productId: 'AccidentExpense'
        }
    },
    {
        path: '/:id/critical-illness/',
        name: 'CriticalIllness',
        component: () => import('../views/CriticalIllness.vue'),
        hasProps: true,
        props: {
            productName: 'Group Critical Illness Insurance',
            productId: 'CriticalIllness'
        }
    },
    {
        path: '/:id/hospital-indemnity/',
        name: 'HospitalIndemnity',
        component: () => import('../views/HospitalIndemnity.vue'),
        hasProps: true,
        props: {
            productName: 'Group Hospital Indemnity Insurance',
            productId: 'HospitalIndemnity'
        }
    },
    {
        path: '/:id/disability-income/',
        name: 'DisabilityIncome',
        component: () => import('../views/DisabilityIncome.vue'),
        hasProps: true,
        props: {
            productName: 'Group Short Term Disability Income Insurance',
            productId: 'DisabilityIncome'
        }
    },
    {
        path: '/:id/term-life/',
        name: 'TermLife',
        component: () => import('../views/TermLife.vue'),
        hasProps: true, 
        props: {
            productName: "Group Term Life Insurance",
            productId: "TermLife"
        }
    },
    {
        path: '/:id/whole-life/',
        name: 'WholeLife',
        component: () => import('../views/WholeLife.vue'),
        hasProps: true,
        props: {
            productName: 'Group Whole Life Insurance',
            productId: 'WholeLife'
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
})

export default router
